import React, { useState } from "react";
import cn from "classnames";
import styles from "./GroupChatModal.module.sass";
import Modal from "../../Modal";
import Icon from "../../Icon";

const GroupChatModal = ({ onClose, onCreate, userType }) => {
    const [groupName, setGroupName] = useState("");
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    
    // Mock users list - will be replaced with actual API call
    const availableUsers = [
        { id: "1", name: "Sarah Johnson", avatar: "/images/content/avatar-2.jpg", type: "creator" },
        { id: "2", name: "Mike Chen", avatar: "/images/content/avatar-3.jpg", type: "host" },
        { id: "3", name: "Emily Davis", avatar: "/images/content/avatar-4.jpg", type: "creator" },
        { id: "4", name: "Alex Thompson", avatar: "/images/content/avatar-5.jpg", type: "host" },
        { id: "5", name: "Jessica Lee", avatar: "/images/content/avatar-1.jpg", type: "creator" },
        { id: "6", name: "David Wilson", avatar: "/images/content/avatar-2.jpg", type: "host" }
    ];
    
    const filteredUsers = availableUsers.filter(user =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
        !selectedMembers.some(member => member.id === user.id)
    );
    
    const toggleMember = (user) => {
        if (selectedMembers.some(member => member.id === user.id)) {
            setSelectedMembers(prev => prev.filter(member => member.id !== user.id));
        } else {
            setSelectedMembers(prev => [...prev, { ...user, role: "member" }]);
        }
    };
    
    const updateMemberRole = (userId, role) => {
        setSelectedMembers(prev => prev.map(member =>
            member.id === userId ? { ...member, role } : member
        ));
    };
    
    const handleCreate = () => {
        if (groupName.trim() && selectedMembers.length > 0) {
            onCreate({
                name: groupName,
                members: selectedMembers,
                creatorName: userType === 'creator' ? 'You' : 'You',
                createdAt: new Date().toISOString()
            });
        }
    };
    
    return (
        <Modal visible={true} onClose={onClose}>
            <div className={styles.modal}>
                <h2 className={styles.title}>Create Group Chat</h2>
                
                <div className={styles.section}>
                    <label className={styles.label}>Group Name</label>
                    <input
                        type="text"
                        placeholder="Enter group name..."
                        value={groupName}
                        onChange={(e) => setGroupName(e.target.value)}
                        className={styles.input}
                        maxLength={50}
                    />
                    <span className={styles.charCount}>
                        {groupName.length}/50
                    </span>
                </div>
                
                <div className={styles.section}>
                    <label className={styles.label}>Add Members</label>
                    <div className={styles.searchBox}>
                        <Icon name="search" size="20" />
                        <input
                            type="text"
                            placeholder="Search users..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className={styles.searchInput}
                        />
                    </div>
                    
                    {selectedMembers.length > 0 && (
                        <div className={styles.selectedMembers}>
                            <div className={styles.selectedHeader}>
                                <span>Selected ({selectedMembers.length})</span>
                            </div>
                            {selectedMembers.map(member => (
                                <div key={member.id} className={styles.selectedMember}>
                                    <img src={member.avatar} alt={member.name} />
                                    <div className={styles.memberInfo}>
                                        <span className={styles.memberName}>{member.name}</span>
                                        <span className={styles.memberType}>{member.type}</span>
                                    </div>
                                    <select
                                        value={member.role}
                                        onChange={(e) => updateMemberRole(member.id, e.target.value)}
                                        className={styles.roleSelect}
                                    >
                                        <option value="member">Member</option>
                                        <option value="admin">Admin</option>
                                    </select>
                                    <button
                                        className={styles.removeBtn}
                                        onClick={() => toggleMember(member)}
                                    >
                                        <Icon name="close" size="16" />
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                    
                    <div className={styles.userList}>
                        {filteredUsers.length > 0 ? (
                            filteredUsers.map(user => (
                                <div
                                    key={user.id}
                                    className={cn(styles.userItem, {
                                        [styles.selected]: selectedMembers.some(m => m.id === user.id)
                                    })}
                                    onClick={() => toggleMember(user)}
                                >
                                    <img src={user.avatar} alt={user.name} />
                                    <div className={styles.userInfo}>
                                        <span className={styles.userName}>{user.name}</span>
                                        <span className={styles.userType}>{user.type}</span>
                                    </div>
                                    <div className={styles.checkbox}>
                                        {selectedMembers.some(m => m.id === user.id) && (
                                            <Icon name="check" size="16" />
                                        )}
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className={styles.emptyState}>
                                {searchQuery ? "No users found" : "No more users to add"}
                            </div>
                        )}
                    </div>
                </div>
                
                <div className={styles.actions}>
                    <button 
                        className={cn("button-stroke", styles.cancelBtn)}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className={cn("button", styles.createBtn)}
                        onClick={handleCreate}
                        disabled={!groupName.trim() || selectedMembers.length === 0}
                    >
                        Create Group
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default GroupChatModal;
